export default "__VITE_ASSET__d80f4cbf__"